var _path, _g, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResourcesBoxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    viewBox: "0 0 30 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_1279",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.917 0.476074H0V21.8381H29.917V0.476074Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_1279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.711 0.476101H20.1C18.6249 0.474636 17.182 0.907272 15.951 1.7201L14.951 2.3791L13.951 1.7201C12.7231 0.908664 11.2838 0.476067 9.812 0.476101H3.205C2.35946 0.472642 1.54709 0.80481 0.946211 1.39969C0.345328 1.99458 0.00502594 2.80357 0 3.6491L0 16.3421C0.00634366 17.1869 0.347194 17.9947 0.947906 18.5886C1.54862 19.1826 2.36023 19.5143 3.205 19.5111L9.811 19.4901C10.8664 19.4962 11.8967 19.8123 12.774 20.3991L14.956 21.8391L17.14 20.4051C18.0191 19.8245 19.0495 19.5153 20.103 19.5161H26.709C27.5545 19.5196 28.3669 19.1874 28.9678 18.5925C29.5687 17.9976 29.909 17.1886 29.914 16.3431V3.6491C29.909 2.80392 29.5689 1.99523 28.9685 1.4004C28.368 0.805575 27.5562 0.473173 26.711 0.476101ZM27.78 16.3421C27.7784 16.6239 27.6651 16.8936 27.4648 17.092C27.2646 17.2904 26.9938 17.4012 26.712 17.4001H20.1C18.6249 17.3986 17.182 17.8313 15.951 18.6441L14.951 19.3031L13.951 18.6441C12.7203 17.8308 11.2772 17.3981 9.802 17.4001H3.205C2.92315 17.4012 2.6524 17.2904 2.45217 17.092C2.25194 16.8936 2.13859 16.6239 2.137 16.3421V3.6491C2.13885 3.36743 2.25232 3.09799 2.45252 2.89985C2.65272 2.70171 2.92333 2.59104 3.205 2.5921H9.812C10.865 2.58984 11.8954 2.89725 12.775 3.4761L14.957 4.9161L17.141 3.4761C18.0194 2.89765 19.0483 2.58992 20.1 2.5911H26.706C26.8461 2.58978 26.985 2.61613 27.1149 2.66864C27.2447 2.72114 27.3629 2.79877 27.4627 2.89707C27.5625 2.99536 27.6419 3.1124 27.6963 3.24145C27.7508 3.3705 27.7792 3.50903 27.78 3.6491V16.3421Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.979 7.5H4.979C4.42672 7.5 3.979 7.94772 3.979 8.5C3.979 9.05228 4.42672 9.5 4.979 9.5H11.979C12.5313 9.5 12.979 9.05228 12.979 8.5C12.979 7.94772 12.5313 7.5 11.979 7.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.979 7.5H17.979C17.4267 7.5 16.979 7.94772 16.979 8.5C16.979 9.05228 17.4267 9.5 17.979 9.5H24.979C25.5313 9.5 25.979 9.05228 25.979 8.5C25.979 7.94772 25.5313 7.5 24.979 7.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.979 11.5H4.979C4.42672 11.5 3.979 11.9477 3.979 12.5C3.979 13.0523 4.42672 13.5 4.979 13.5H11.979C12.5313 13.5 12.979 13.0523 12.979 12.5C12.979 11.9477 12.5313 11.5 11.979 11.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.979 11.5H17.979C17.4267 11.5 16.979 11.9477 16.979 12.5C16.979 13.0523 17.4267 13.5 17.979 13.5H24.979C25.5313 13.5 25.979 13.0523 25.979 12.5C25.979 11.9477 25.5313 11.5 24.979 11.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourcesBoxIcon);
export default __webpack_public_path__ + "static/media/resources-box-icon.5ab65d506a7d89de571f44b3578c8a26.svg";
export { ForwardRef as ReactComponent };